import { SYMBOL_HYPHEN } from '../../../../../../constants/common'
import { CALENDAR_GRID_WEEK_SINGLE_LANE_COUNT } from '../../../CalendarGridWeek.constants'

export function getCalendarGridTimedItemDragId({ day, item }) {
  return [item.id, day].join(SYMBOL_HYPHEN)
}

export function getHasCalendarGridGroupSeveralLanes(laneCount) {
  return laneCount > CALENDAR_GRID_WEEK_SINGLE_LANE_COUNT
}

export function getIsCalendarGridTimedItemDragDisabled({
  canMoveItemsInTime,
  item,
}) {
  return !canMoveItemsInTime || !item.isTimeDraggable
}
